import { assetsDataManagerObjectClassSettingsEntryPoint } from '@jira/spa-apps__data-manager-object-class-settings/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { assetsDataManagerObjectClassSettingsRoute } from '@atlassian/jira-router-routes-assets-data-manager-routes/src/assetsDataManagerObjectClassSettingsRoute.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point';

const assetsDataManagerObjectClassSettingsPageEntryPoint = createChromelessEntryPoint({
	main: assetsDataManagerObjectClassSettingsEntryPoint,
});

export const assetsDataManagerObjectClassSettingsRouteEntry = createEntry(
	assetsDataManagerObjectClassSettingsRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		perfMetricKey: 'assets-data-manager-object-class-settings',
		pageId: () => 'spa-apps/assets-data-manager-object-class-settings',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],

		entryPoint() {
			return fg('assets_data_manager_jira_spa')
				? assetsDataManagerObjectClassSettingsPageEntryPoint
				: undefined;
		},

		component: fg('assets_data_manager_jira_spa') ? undefined : ErrorPagesNotFound,

		meta: {
			reporting: {
				id: APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE,
				packageName: toPackageName(APP_NAMES.ASSETS_APP_DATA_MANAGER_OBJECT_CLASS_SETTINGS_PAGE),
				teamName: 'Aurum',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-assets-data-manager-entries/src/assetsDataManagerObjectClassSettingsRouteEntry.tsx',
				whichExportToUse: 'assetsDataManagerObjectClassSettingsRouteEntry',
			},

			enabled: true,
		},
	}),
);
